<div class="row">
  <div class="col-6">
    <h3>Inclusion Criteria</h3>
    <h4>Candidates are eligible for inclusion in the clinical trial only if required criteria apply.</h4>
    <div class="expander info-details">
      <div appCriteriaForm *ngIf="inclusionRequiredCriteria" class="card collapsed" [criteria]="inclusionRequiredCriteria" [groupId]="group.id"></div>
      <div appCriteriaForm *ngIf="inclusionOptionalCriteria" class="card collapsed" [criteria]="inclusionOptionalCriteria" [groupId]="group.id"></div>
      <div appInformationalCriteria *ngIf="inclusionInformationalCriteria"  class="card collapsed" [informationalCriteria]="inclusionInformationalCriteria" [groupId]="group.id"></div>
    </div>
  </div>
  <div class="col-6">
    <h3>Exclusion Criteria</h3>
    <h4>Candidates are excluded from the clinical trial if any of required criteria apply.</h4>
    <div class="expander">
      <div appCriteriaForm *ngIf="exclusionRequiredCriteria" class="card collapsed" [criteria]="exclusionRequiredCriteria" [groupId]="group.id"></div>
      <div appCriteriaForm *ngIf="exclusionOptionalCriteria" class="card collapsed" [criteria]="exclusionOptionalCriteria" [groupId]="group.id"></div>
      <div appInformationalCriteria *ngIf="exclusionInformationalCriteria" class="card collapsed" [informationalCriteria]="exclusionInformationalCriteria" [groupId]="group.id"></div>
    </div>
  </div>
</div>
